import axios from "axios";
import { BASE_URL } from "../config/config";

const axiosInstance = axios.create({
  baseURL: BASE_URL, // Base URL from .env
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor (Token Attach)
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response Interceptor (Error Handling)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = "/signin";
    }
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
